import type { IHttpService, ITimeoutService } from "angular";
import { module } from "angular";
import { tap } from "rxjs/operators";

import "angular-translate";

import type { IResponseWithLoading } from "App/Modules/Models";

import type { IPageRootScope } from "./IPageRootScope";
import type { IPageService } from "./IPageService";

export class PageService implements IPageService {
    public static $inject = ["$rootScope", "$http", "$timeout", "$translate"];

    private pendingRequests = 0;

    constructor(
        private readonly $rootScope: IPageRootScope,
        private readonly $http: IHttpService,
        private readonly $timeout: ITimeoutService,
        private readonly $translate: angular.translate.ITranslateService,
    ) {
        this.initRootScope();
        this.initTranslateHooks();
    }

    // /**
    //  * You can also use an existing operator like so
    //  */
    // const takeEveryNthSimple = (n: number) => <T>(source: Observable<T>) =>
    // source.pipe(filter((value, index) => index % n === 0 ))

    // /**
    // * And since pipeable operators return functions, you can further simplify like so
    // */
    // const takeEveryNthSimplest = (n: number) => filter((value, index) => index % n === 0);

    public addLoading<T>() {
        let isLoading: boolean;
        return tap<IResponseWithLoading<T>>(
            (response) => {
                if (response.isLoading && isLoading === undefined) {
                    isLoading = true;
                    this.incrementLoading();
                } else if (!response.isLoading && isLoading) {
                    isLoading = false;
                    this.decrementLoading();
                }
                this.$rootScope.$applyAsync();
            },
            () => {
                if (isLoading) {
                    isLoading = false;
                    this.$rootScope.$applyAsync();
                    this.decrementLoading();
                }
            },
            () => {
                if (isLoading) {
                    isLoading = false;
                    this.decrementLoading();
                    this.$rootScope.$applyAsync();
                }
            },
        );
    }

    // public addLoadingOld<T>(responseWithLoading: Observable<IResponseWithLoading<T>>) {
    //     let isLoading: boolean;
    //     return responseWithLoading.pipe(
    //         tap(
    //             (response) => {
    //                 if (response.isLoading && isLoading === undefined) {
    //                     isLoading = true;
    //                     this.incrementLoading();
    //                 } else if (!response.isLoading && isLoading) {
    //                     isLoading = false;
    //                     this.decrementLoading();
    //                 }
    //             },
    //             (error) => {
    //                 if (isLoading) {
    //                     isLoading = false;
    //                     this.decrementLoading();
    //                 }
    //             },
    //             () => {
    //                 if (isLoading) {
    //                     isLoading = false;
    //                     this.decrementLoading();
    //                 }
    //             },
    //         ));
    // }

    public incrementLoading() {
        this.pendingRequests++;
    }

    public decrementLoading() {
        this.pendingRequests--;
    }

    private initRootScope() {
        this.$rootScope.page = {
            isChangingLanguage: true,
            isLoading: () => {
                return this.pendingRequests > 0;
            },
        };

        // eslint-disable-next-line
        this.$translate.onReady().then(() => {
            this.$rootScope.page.isChangingLanguage = false;
        });
    }

    private initTranslateHooks() {
        this.$rootScope.$on("$translateChangeStart", () => {
            this.$rootScope.page.isChangingLanguage = true;
        });

        this.$rootScope.$on("$translateChangeSuccess", () => {
            // eslint-disable-next-line
            this.$timeout(() => {
                this.$rootScope.page.isChangingLanguage = false;
            });
        });

        this.$rootScope.$on("$translateChangeError", () => {
            this.$rootScope.page.isChangingLanguage = false;
        });

        this.$rootScope.$on("$translateRefreshStart", () => {
            this.$rootScope.page.isChangingLanguage = true;
        });

        this.$rootScope.$on("$translateRefreshEnd", () => {
            this.$rootScope.page.isChangingLanguage = false;
        });
    }
}

module("mmServices").service("irPageService", PageService);
